import { action, computed, makeObservable, observable } from 'mobx';
import { AwardJudging, NominationJudgedSummary } from '../../models';
import { getCountryAwardJudgingKey } from '../shared-components/award-judging-box-section/country-award-judging-key';

export class JudgingDashboardPageUiStore {
  @observable awardJudgings: AwardJudging[] = [];

  @observable countryAwardJudgings: AwardJudging[] = [];

  @observable awardJudgingAlertMessages = new Map<number, string>();

  @observable countryAwardJudgingAlertMessages = new Map<string, string>();

  @observable nominationJudgedSummaries: NominationJudgedSummary[] = [];

  constructor() {
    makeObservable(this);
  }

  @action
  resetStates(): void {
    this.awardJudgings = [];
    this.countryAwardJudgings = [];
    this.awardJudgingAlertMessages.clear();
    this.countryAwardJudgingAlertMessages.clear();
    this.nominationJudgedSummaries = [];
  }

  /* Judge */

  @action
  setAwardJudgings(awardJudgings: AwardJudging[]): void {
    this.awardJudgings = awardJudgings.filter(awardJudging => awardJudging.countryId === null);
    this.countryAwardJudgings = awardJudgings.filter(awardJudging => awardJudging.countryId !== null);
  }

  @action
  setAwardJudgingAlertMessage(awardId: number, message: string): void {
    this.awardJudgingAlertMessages.set(awardId, message);
  }

  @action
  setCountryAwardJudgingAlertMessage(awardId: number, countryId: number, message: string): void {
    this.countryAwardJudgingAlertMessages.set(getCountryAwardJudgingKey(awardId, countryId), message);
  }

  @action
  clearAwardJudgingAlertMessage(awardId: number): void {
    this.awardJudgingAlertMessages.delete(awardId);
  }

  @action
  clearCountryAwardJudgingAlertMessage(awardId: number, countryId: number): void {
    this.countryAwardJudgingAlertMessages.delete(getCountryAwardJudgingKey(awardId, countryId));
  }

  @computed
  get hasJudgings(): boolean {
    return this.awardJudgings.length > 0 || this.countryAwardJudgings.length > 0;
  }

  @action
  setNominationJudgedSummaries(nominationJudgedSummaries: NominationJudgedSummary[]): void {
    this.nominationJudgedSummaries = nominationJudgedSummaries;
  }

  @computed
  get hasNominationJudgedSummaries(): boolean {
    return this.nominationJudgedSummaries.length > 0;
  }
}
